module.exports = __webpack_public_path__ + "img/05107e4b6d0c1215a62cf96c09b7516.9a897798.jpg";